import { render } from "./Greetings.vue?vue&type=template&id=187da731"
import script from "./Greetings.vue?vue&type=script&lang=js"
export * from "./Greetings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricardo/Sites/customizer/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__